import { Component, Inject, HostListener } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { PendingDeliveryOptions } from "./pending-delivery-options.component";
@Component({
  selector: "app-pending-delivery-dialog",
  templateUrl: "./pending-delivery-dialog.component.html",
  styleUrls: ["./pending-delivery-dialog.component.scss"]
})
export class PendingDeliveryDialogComponent
{
  title: string;
  message: string;

  constructor(
    public dialog: MatDialog,
    public router: Router,
    public dialogRef: MatDialogRef<PendingDeliveryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PendingDeliveryOptions,
  )
  {
    this.title = data.title;
    this.message = data.message;
  }

  @HostListener("window:keyup.esc") handleEscapeKey()
  {
    this.handleNoClick();
  }

  @HostListener("window:keyup.enter") handleEnterKey()
  {
    this.handleYesClick();
  }

  public handleYesClick(): void
  {
    this.dialogRef.close(true);
  }

  public handleNoClick(): void
  {
    this.dialog.closeAll();
    this.router.navigate(["/home"]);
  }
}
